const version = require('@temp/js/version');

const generateVersionString = () => {
    return 'ProPoint/' + version.branch.substr(0, 50) + '/' + version.commit + '/' + version.builtAt;
};

module.exports = {
    generateVersionString,
};
